import React, { useEffect, useState } from 'react'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import { Helmet } from 'react-helmet/es/Helmet'
import PageTitle from '../../components/PageTitle'
import AppPageHeader from '../../components/AppPageHeader'
import { useHistory, useParams } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import SpinnerInlineComponent from '../../components/SpinnerInlineComponent'
import { Button, message, Tabs } from 'antd'
import styled from 'styled-components'
import ProposalAdvanceInfo from './ProposalAdvanceInfo'
import ProposalAdvanceComment from './ProposalAdvanceComment'
import ProposalAdvanceAction from './ProposalAdvanceAction'
import { StatusTag } from '../../components/Common/StatusTag'
import { TYPE_STATUS } from '../../constants'
import { systemName } from '../../config'
import { ArrowLeftBroken } from '../../components/AppIcon'

const ProposalDetailWrapper = styled.div`
  .proposal-row {
    display: ${props => (props.isHidden ? 'none' : 'flex')};
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;
    .proposal-left {
      flex: 1;
      min-width: 0;
    }
    .proposal-right {
      width: 372px;
      flex-shrink: 0;
    }
    @media screen and (max-width: 1299px) {
      display: ${props => (props.isHidden ? 'none' : 'block')};
      .proposal-left {
        margin-bottom: 20px;
      }
      .proposal-right {
        width: 100%;
      }
    }
  }
`

const ProposalAdvanceDetailPage = props => {
  const { id: proposalAdvanceCode } = useParams()
  const { proposalAdvanceStore, selectPeopleStore } = props
  const { proposalAdvanceDetail } = proposalAdvanceStore
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!proposalAdvanceCode) return
    ;(async () => {
      try {
        setIsLoading(true)
        await proposalAdvanceStore.getProposalAdvanceDetail(proposalAdvanceCode)
      } catch (err) {
        console.log(err)
        history.push('/proposal-advance')
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        setIsLoading(false)
      }
    })()
    return () => {
      proposalAdvanceStore.clearProposalAdvanceDetail()
      selectPeopleStore.clearSelected()
    }
  }, [proposalAdvanceCode])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tạm ứng | {systemName} Tạm ứng</title>
      </Helmet>
      <AppPageHeader
        title={
          <>
            Chi tiết trình tạm ứng{' '}
            {StatusTag(
              TYPE_STATUS.PROPOSAL,
              proposalAdvanceDetail.proposal_status
            )}
          </>
        }
        showBackButton
      />

      {isLoading && (
        <ContentBlockWrapper
          style={{ position: 'relative', minHeight: 'calc(100vh - 200px)' }}>
          <SpinnerInlineComponent
            alignItems
            isLoading={isLoading}
            size={'small'}
            noBackground
            tip={'Đang tải chi tiết trình tạm ứng...'}
          />
        </ContentBlockWrapper>
      )}
      <ProposalDetailWrapper isHidden={isLoading}>
        <div className={'proposal-row'}>
          <div className="proposal-left">
            <ProposalAdvanceInfo />
          </div>
          <div className="proposal-right">
            <div style={{ marginBottom: 20 }}>
              {!isLoading && <ProposalAdvanceAction />}
            </div>
            <div className="custom-create-page-content-wrapper">
              <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Ý kiến" key="1">
                  <ProposalAdvanceComment />
                  <SpinnerInlineComponent sizeSpin={'small'} />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </ProposalDetailWrapper>
    </DashboardLayout>
  )
}

ProposalAdvanceDetailPage.propTypes = {}
export default inject(
  'proposalAdvanceStore',
  'selectPeopleStore'
)(observer(ProposalAdvanceDetailPage))
